import { InfinitySpin } from "react-loader-spinner";

export const Loader = () => {
  return <InfinitySpin width="200" color="#3f51b5" visible={true} />;
};
